import React from 'react';
import { translate } from '../Services/translation';

export default (props) => {
  const { discountRow } = props;

  return (
    <div className='cart-discount'>
      <div className="[ checkout-cart-item__product-name ][ color-error lh-1 ]">
        {translate("checkout.order.discount")} ({discountRow.name})
      </div>
      <div className='text-medium color-error lh-1 bold'>
        {discountRow.price}
      </div>
    </div>
  );
};